import React from 'react';
import { Bot, User } from 'lucide-react';

interface ChatMessageProps {
  type: 'user' | 'assistant';
  content: string;
  timestamp: Date;
}

export default function ChatMessage({ type, content, timestamp }: ChatMessageProps) {
  return (
    <div className={`flex items-start space-x-3 ${
      type === 'user' ? 'flex-row-reverse space-x-reverse' : ''
    }`}>
      <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
        type === 'assistant' ? 'bg-blue-100' : 'bg-gray-100'
      }`}>
        {type === 'assistant' ? (
          <Bot className="w-5 h-5 text-blue-500" />
        ) : (
          <User className="w-5 h-5 text-gray-500" />
        )}
      </div>
      <div className={`max-w-[80%] rounded-lg p-4 ${
        type === 'assistant'
          ? 'bg-blue-50 text-gray-800'
          : 'bg-gray-100 text-gray-800'
      }`}>
        {content}
      </div>
    </div>
  );
}